import React from "react";
import { connect } from 'react-redux';
import { fetchUserChordPreference } from "../../api/chords/actions";
import { fetchInstruments } from '../../api/instrument/actions';
import { fetchProfile } from '../../api/profile/actions';
import { fetchSong } from '../../api/song/actions';
import { fetchSongbookDetail, modifySongbook } from "../../api/songbooks/actions";
import Song from '../../components/song';
import { track } from '../../usage';


class SongbookPlayContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      songIndex: 0
    }

    this.nextSong = this.nextSong.bind(this)
    this.prevSong = this.prevSong.bind(this)
    this.setSong = this.setSong.bind(this)
    this.completeUpdate = this.completeUpdate.bind(this)
    this.fetchSongForIndex = this.fetchSongForIndex.bind(this)
    
    this.channel = null
  }

  getSongs(songbookData=this.props.songbook.data) {
    if (songbookData && Array.isArray(songbookData.songs)) {
      return songbookData.songs
    }
    return []
  }

  getCurrentSongIndex(songbookData=this.props.songbook.data) {
    const songs = this.getSongs(songbookData)

    if (songs.length === 0) {
      return -1
    }

    if (songbookData && songbookData.current_song) {
      return songs.findIndex((relation) => relation.song && relation.song.id === songbookData.current_song)
    }

    return -1
  }

  getSafeSongIndex(songbookData=this.props.songbook.data, preferredIndex=this.state.songIndex) {
    const songs = this.getSongs(songbookData)

    if (songs.length === 0) {
      return -1
    }

    if (preferredIndex >= 0 && preferredIndex < songs.length) {
      return preferredIndex
    }

    return 0
  }

  fetchSongForIndex(songIndex, songbookData=this.props.songbook.data) {
    const songs = this.getSongs(songbookData)

    if (songIndex < 0 || songIndex >= songs.length) {
      return Promise.resolve()
    }

    const collectionRelation = songs[songIndex]

    return Promise.resolve(this.props.dispatch(fetchSong(
      collectionRelation.song.id,
      collectionRelation.key,
      this.props.profile.instrument_preference
    ))).then(() => {
      this.props.dispatch(fetchUserChordPreference(collectionRelation.song.id))
    })
  }

  completeUpdate() {
    Promise.resolve(this.props.dispatch(fetchSongbookDetail(this.props.id, this.props.public)))
      .then(() => {
        Promise.resolve(this.props.dispatch(fetchProfile()))
          .then(() => {
            this.props.dispatch(fetchInstruments())

            let songIndex = this.getCurrentSongIndex(this.props.songbook.data)
            if (songIndex === -1) {
              songIndex = this.getSafeSongIndex(this.props.songbook.data, this.state.songIndex)
            }

            if (songIndex === -1) {
              return
            }

            if (songIndex !== this.state.songIndex) {
              this.setState({songIndex})
              return
            }

            this.fetchSongForIndex(songIndex, this.props.songbook.data)
          })
      })
  }

  componentDidMount() {
    track('songbook_played');
    this.completeUpdate();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.songIndex !== this.state.songIndex) {
      const songIndex = this.getSafeSongIndex(this.props.songbook.data, this.state.songIndex)

      if (songIndex === -1) {
        return
      }

      if (songIndex !== this.state.songIndex) {
        this.setState({songIndex})
        return
      }

      const idToFetch = this.props.songbook.data.songs[songIndex].song.id;
      Promise.resolve(this.fetchSongForIndex(songIndex, this.props.songbook.data))
      .then(() => {
        if (this.props.user.username === this.props.songbook.data.owner) {
          this.props.dispatch(modifySongbook(this.props.songbook.data.id, {'current_song': idToFetch}))
        }
      })
    }

    if (this.props.songbook.data && JSON.stringify(prevProps.songbook.data) !== JSON.stringify(this.props.songbook.data)) {
        this.channel = window.pusherClient.subscribe(`presence-play-${this.props.songbook.data.id}`);
        this.channel.bind('client-song-change', (data) => {
          this.setState({
            songIndex: data.songIndex
          });
        });
        this.channel.bind('song-added', (data) => {
          this.completeUpdate();
        });
        this.channel.bind('song-removed', (data) => {
          this.completeUpdate();
        });
    }
  }

  nextSong() {
    const songs = this.getSongs()
    if (songs.length === 0) {
      return
    }

    let idx = this.state.songIndex + 1
    if (idx >= songs.length) {
      idx = 0
    }
    this.setState({
      songIndex: idx
    })
    if (this.channel && this.props.user.username === this.props.songbook.data.owner) {
      this.channel.trigger('client-song-change', {'songIndex': idx})
    }
    const titleContainer = document.getElementsByClassName("title-container")[0]
    if (titleContainer) {
      titleContainer.scrollIntoView();
    }
  }

  prevSong() {
    const songs = this.getSongs()
    if (songs.length === 0) {
      return
    }

    let idx = this.state.songIndex - 1
    if (idx < 0) {
      idx = songs.length - 1
    }
    this.setState({
      songIndex: idx
    })
    if (this.channel && this.props.user.username === this.props.songbook.data.owner) {
      this.channel.trigger('client-song-change', {'songIndex': idx})
    }

    window.scrollTo(0,0)
  }

  setSong(idx) {
    const songIndex = this.getSafeSongIndex(this.props.songbook.data, idx)

    if (songIndex === -1) {
      return
    }

    this.setState({
      songIndex
    })
    if (this.channel && this.props.user.username === this.props.songbook.data.owner) {
      this.channel.trigger('client-song-change', {'songIndex': songIndex})
    }
  }

  render() {
    const { song, songbook, songbooks, favourites, instruments, profile } = this.props
    const songIndex = this.getSafeSongIndex(songbook.data, this.state.songIndex)
    let collectionRelation = null

    try {
      if (songIndex !== -1) {
        collectionRelation = this.props.songbook.data.songs[songIndex]
      }
    } catch (e) {void(0)}

    return (
      <Song song={song.data} collectionRelation={collectionRelation} playSongbook={songbook.data} setSong={this.setSong} nextSong={this.nextSong} prevSong={this.prevSong} songbooks={songbooks.privateSongbooks} favourites={favourites.data} {...profile.ui_preferences} instrument_preference={profile.ui_preferences.instrument_preference} profileHasFetched={profile.hasFetched} instruments={instruments.data} isFetching={song.isFetching} user={this.props.user} dispatch={this.props.dispatch} songIndex={songIndex === -1 ? 0 : songIndex} />
    )
  }
}

SongbookPlayContainer.defaultProps = {
}

function mapStateToProps(state) {

  var f = {
    song: {},
    songbook: {},
    songbooks: {},
    favourites: {},
    instruments: [],
    profile: {},
    user: {},
  }
  f.song = (state.song === undefined) ? {} : state.song
  f.songbook = (state.songbook === undefined) ? [] : state.songbook
  f.songbooks = (state.songbooks === undefined) ? [] : state.songbooks
  f.instruments = (state.instruments === undefined) ? {} : state.instruments
  f.profile = (state.profile === undefined) ? {} : state.profile
  f.favourites = (state.favourites === undefined) ? [] : state.favourites
  f.user = (state.user === undefined) ? [] : state.user
  return f;
}

export default connect(mapStateToProps)(SongbookPlayContainer);
